"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var style_1 = require("../../../style");
var Tooltip_1 = __importDefault(require("../../Tooltip"));
var Avatar_1 = __importDefault(require("./Avatar"));
var AvatarListItem_1 = __importDefault(require("./AvatarListItem"));
var styles_1 = require("./styles");
var AvatarGroup = function (_a) {
    var _b = _a.children, children = _b === void 0 ? [] : _b, _c = _a.showAdd, showAdd = _c === void 0 ? false : _c, _d = _a.addButtonTooltip, addButtonTooltip = _d === void 0 ? '' : _d, onClickAdd = _a.onClickAdd, _e = _a.size, size = _e === void 0 ? 'md' : _e, _f = _a.limit, limit = _f === void 0 ? 10 : _f;
    var theme = style_1.useTheme();
    var styles = styles_1.getAvatarGroupStyles(theme, size);
    var avatarStyles = styles_1.getAvatarStyles(theme, styles_1.sizesMap[size].root, styles_1.sizesMap[size].font, styles_1.sizesMap[size].indicator);
    var updateSize = function (child) {
        return react_2.default.cloneElement(child, {
            size: size,
        });
    };
    var groupedAvatars = react_2.Children.map(children, updateSize);
    var totalAvatars = groupedAvatars.length;
    var remainingAvatars = limit >= totalAvatars ? 0 : totalAvatars - limit;
    return (react_1.jsx("div", { css: styles.avatarGroupWrapper },
        groupedAvatars.slice(0, limit),
        remainingAvatars > 0 && (react_1.jsx(Tooltip_1.default
        /* TODO: We need "arrowColor" support from Tooltip component to enable showArrow. */
        , { 
            /* TODO: We need "arrowColor" support from Tooltip component to enable showArrow. */
            showArrow: false, placement: "bottom", overlayInnerStyle: styles_1.getOverlayInnerStyles(theme), overlay: react_1.jsx("div", { css: { maxHeight: 300, overflow: 'auto' } }, react_2.Children.map(children, function (child) { return (react_1.jsx(AvatarListItem_1.default, __assign({}, child.props, { size: size }))); })) },
            react_1.jsx("div", { css: react_1.css([avatarStyles.root, avatarStyles.text]) },
                react_1.jsx("span", { css: avatarStyles.content },
                    "+",
                    remainingAvatars)))),
        showAdd && (react_1.jsx("div", { style: { marginLeft: 8, boxShadow: 'none' } },
            react_1.jsx(Avatar_1.default.Add, { size: size, onClick: onClickAdd, addButtonTooltip: addButtonTooltip })))));
};
exports.default = AvatarGroup;
